

export class TimeZoneOutputWithStatus implements ITimeZoneOutputWithStatus {
    /** The auto-generated id of the time zone master */
    time_zone_id!: number;
    /** The time zone with 255 character limit */
    time_zone!: string;
    /** The time difference between time zone time zone master */
    time_difference!: number;
    /** Manage status of vehicle type. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: ITimeZoneOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.time_zone_id = _data["time_zone_id"];
            this.time_zone = _data["time_zone"];
            this.time_difference = _data["time_difference"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TimeZoneOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new TimeZoneOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["time_zone_id"] = this.time_zone_id;
        data["time_zone"] = this.time_zone;
        data["time_difference"] = this.time_difference;
        data["status"] = this.status;
        return data; 
    }
}

export interface ITimeZoneOutputWithStatus {
    /** The auto-generated id of the time zone master */
    time_zone_id: number;
    /** The time zone with 255 character limit */
    time_zone: string;
    /** The time difference between time zone time zone master */
    time_difference: number;
    /** Manage status of vehicle type. 0 For De-active, 1 For Active */
    status: number;
}

